<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/investidor/batches/${$route.params.idBatch}/startups`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para as startups
              do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div
          class="col-lg-4 order-lg-1 order-md-0 vld-parent"
          ref="card_startup"
        >
          <startup-batch-info
            v-if="batch && startup"
            :startup="startup"
            :batch="batch"
            basePage="investidor"
            class="flex-grow-1"
          />
        </div>
        <div class="col-lg-8 mt-lg-0 mt-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Apresentação -
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h6 class="heading-small text-muted mb-4">
                <i class="fab fa-youtube mr-1"></i> Pitch vídeo
              </h6>
              <div class="video-wrap" v-if="startup.pitch_video_youtube_id">
                <div class="video-container">
                  <iframe
                    :src="getUrl(startup.pitch_video_youtube_id)"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  >
                  </iframe>
                </div>
              </div>
              <div v-else class="text-center">
                <badge type="info"> Pitch vídeo não encontrado </badge>
              </div>
            </div>
            <hr class="my-4" />
            <div class="col-12">
              <div>
                <h6 class="heading-small text-muted mb-4">
                  <i class="far fa-file-pdf mr-1"></i> Pitch deck
                  <a
                    v-if="startup && startup.deck_url"
                    :href="startup.deck_url"
                    target="_blank"
                    class="btn btn-sm btn-primary float-right"
                  >
                    <i class="fas fa-file-download"></i> Baixar
                  </a>
                </h6>
                <div class="row mt-3">
                  <div class="col-12 text-center">
                    <div v-if="startup && startup.deck_url">
                      <pdf
                        style="margin: 0 auto; width: 90%; max-width: 700px"
                        ref="startupDeck"
                        :src="startup.deck_url"
                        :page="deck.page"
                        @num-pages="deck.pageCount = $event"
                        @page-loaded="deck.currentPage = $event"
                      ></pdf>
                      <div class="text-center mt-2">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previousPage()"
                          :disabled="this.deck.page <= 1"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{ deck.currentPage }} / {{ deck.pageCount }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="nextPage()"
                          :disabled="this.deck.page >= this.deck.pageCount"
                        ></base-button>
                      </div>
                    </div>
                    <div v-else>
                      <badge type="info"> Pitch deck não encontrado </badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartupBatchInfo from "@/components/StartupDashboard/StartupBatchInfo";

import api from "@/services/api.js";
import pdf from "vue-pdf";

export default {
  components: {
    StartupBatchInfo,
    pdf,
  },
  data() {
    return {
      batch: "",
      startup: "",
      deck: {
        page: 1,
        currentPage: 0,
        pageCount: 0,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
      opacity: 0,
    });
    await this.loadStartupPresentation();
    loader.hide();
  },
  methods: {
    async loadStartupPresentation() {
      try {
        const { data } = await api.get(
          `/investor-batch-startup/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}?only_basic_info=true`
        );
        if (!data.batch) throw new Error("Batch not found");
        if (!data.startup) throw new Error("Startup not found");
        this.batch = data.batch;
        this.startup = data.startup;
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };

        return;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar informações");
        this.$router.push(
          `/investidor/batches/${this.$route.params.idBatch}/startups`
        );
      }
    },
    getUrl(youtubeVideoId) {
      return `https://www.youtube.com/embed/${youtubeVideoId}`;
    },
    nextPage() {
      if (this.deck.pageCount > this.deck.page) this.deck.page++;
    },
    previousPage() {
      if (this.deck.page > 1) this.deck.page--;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}

.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.video-wrap {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
</style>
